export default __webpack_public_path__ + "static/media/singemaison.bab0dec6.png";